import { render, staticRenderFns } from "./ProviderSearch.vue?vue&type=template&id=2700f2dc&scoped=true&"
import script from "./ProviderSearch.vue?vue&type=script&lang=js&"
export * from "./ProviderSearch.vue?vue&type=script&lang=js&"
import style0 from "./ProviderSearch.vue?vue&type=style&index=0&id=2700f2dc&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2700f2dc",
  null
  
)

export default component.exports